import { h, Component } from 'preact';
import React from 'react';
import {
  showPopup, isBigcommercePlatform, getAddToCartButton, addStylesForElement,
  detectIEEdge, isMobile, tractGA4Events
} from 'embed/helpers'

// import { connect } from 'react-redux'
// import { setPopupTrigger } from 'embed/actions'

class Button extends Component {
  constructor(props) {
    super(props);
    this.state = {
      buttonId: 'mf_button',
      clickMFButtonEvent: detectIEEdge() || isMobile() ? null : new Event('clickMFButton'),
      bigcommerceForm: null,
      addToCartButton: null,
      borrowedСlasses: '',
      oldContainer: null
    }
  }

  componentDidMount() {
    this.renderComponentSetup()
  }

  componentWillUpdate(nextProps, nextState) {
    this.renderComponentSetup()
  }

  renderComponentSetup(){
    const mfButton = document.querySelector("#mf_container button, #mf_button button");
    const oldContainer = document.querySelector("#mf_button button");
    this.setState({ oldContainer: oldContainer })
    this.addEventListenersForButton(mfButton)
    if (isBigcommercePlatform()){
      this.bigcommerceSetup(mfButton);
    } else {
      this.shopifySetup(mfButton);
    }
    addStylesForElement(mfButton, 'button')
  }


  bigcommerceSetup(mfButton) {
    const form = document.querySelector('form[data-cart-item-add]');
    const options = form.querySelector('[data-product-option-change]');
    const addToCartButton = form.querySelector('#form-action-addToCart, [type="submit"]');

    this.setState({
      bigcommerceForm: form,
      addToCartButton: addToCartButton,
      borrowedСlasses: addToCartButton ? addToCartButton.className : '',
      mfButtonId: addToCartButton ? addToCartButton.id : 'auto_mf_button'
    })
    if (options && addToCartButton) {
      options.addEventListener('change', (e) => {
        setTimeout(() => {
          if (addToCartButton.disabled) {
            mfButton.disabled = true;
            mfButton.style.cursor = 'not-allowed';
          } else {
            mfButton.disabled = false;
            mfButton.style.cursor = 'pointer';
          }
        }, 1000);
      })
    }
  }

  shopifySetup(mfButton) {
    const form = document.getElementsByClassName('mf_product_form')[0];
    const addToCartButton = getAddToCartButton(form);
    this.setState({
      addToCartButton: addToCartButton,
      borrowedСlasses: addToCartButton ? addToCartButton.className.replace('ProductForm__AddToCart','') : '',
      mfButtonId: addToCartButton ? addToCartButton.id : 'auto_mf_button'
    })
  }

  addEventListenersForButton(mfButton) {
    if (mfButton) {
      mfButton.addEventListener('click', (e) => {
        this.mfButtonPressed(e, mfButton)
      });
      mfButton.addEventListener('touch ', (e) => {
        this.mfButtonPressed(e, mfButton)
      });
    }
  }

  mfButtonPressed(e, mfButton) {
    const { userSettings } = this.props
    e.preventDefault()
    e.stopImmediatePropagation();
    if (isBigcommercePlatform() && this.invalidBigcommerceForm()) {
      this.state.addToCartButton.click();
      return
    }
    if (this.state.clickMFButtonEvent) {
      mfButton.dispatchEvent(this.state.clickMFButtonEvent);
    }
    tractGA4Events({
      category: 'MAO - Offers',
      action: 'MAO - Make an Offer Button clicked',
      label: 'On User click  Make An Offer Button',
      trackingId: userSettings && userSettings.google_analytics_code,
      analyticsActive: userSettings.theme_setting.data.show_gac
    })
    showPopup()
  }

  buttonStyles() {
    const userSettings = this.props.userSettings;
    return {
      backgroundColor: userSettings.button_background_color,
      color: userSettings.button_font_color,
      borderColor: 'transparent',
      outline: 'transparent'
    }
  }

  invalidBigcommerceForm() {
    return !this.state.bigcommerceForm.checkValidity()
  }

  render(props, state) {
    if (props.products.length && props.userSettings.product_button && !props.userSettings.disabled_in_shopfront) {
      if (props.userSettings.automatic_button_style) {
        return (
          <button id={state.mfButtonId}
            class={state.borrowedСlasses + ' ' + this.state.buttonId}
            style={{...this.buttonStyles(), display: props.userSettings.check_variant_quantity && 'none' }}>
            <style>{props.userSettings.modal_css}</style>
            {props.userSettings.button_text}
          </button>
        )
      } else if (props.oldContainer) {
        return (
          <button style={{...this.buttonStyles(), display: props.userSettings.check_variant_quantity && 'none'}}>
            <style>{props.userSettings.modal_css}</style>
            {props.userSettings.button_text}
          </button>
        )
      } else {
        return (
          <span id={this.state.buttonId}>
            <style>{props.userSettings.modal_css}</style>
            <button style={{...this.buttonStyles(), display: props.userSettings.check_variant_quantity && 'none'}}>
              {props.userSettings.button_text}
            </button>
          </span>
        )
      }
    }
  }
}

// const mapStateToProps = (state, ownProps) => {
//   return {}
// }

// const mapDispatchToProps = (dispatch, ownProps) => {
//   return {
//     setPopupTrigger: (trigger) => {
//       dispatch(setPopupTrigger(trigger))
//     }
//   }
// }

// export default connect(mapStateToProps, mapDispatchToProps)(Button);

export default Button;
